export default {
  primary: '#FF9900',
  disabled: '#DDDDDD',
  success: '#78be20',
  error: '#f04f23'
}
